import {type UpmPlantsHierarchyNode, UpmPlantsHierarchyType} from '@domain/upm'
import {FilterSelectProps, FilterSelect} from '@widgets/common-filters'

type AreaFilterProps<TName extends string> = Omit<FilterSelectProps<string, TName>, 'options'> & {
  hierarchyData?: UpmPlantsHierarchyNode
}

export const AreaFilter = <TName extends string>({
  hierarchyData,
  ...props
}: AreaFilterProps<TName>) => {
  const options = (hierarchyData?.children ?? [])
    .filter((node) => node.type === UpmPlantsHierarchyType.ManagementArea)
    .map((node) => ({
      value: node.hierarchyId,
      label: node.name
    }))

  return <FilterSelect {...props} options={options} />
}
